import { render } from "./ContentButton.vue?vue&type=template&id=6756f3a9"
import script from "./ContentButton.vue?vue&type=script&lang=js"
export * from "./ContentButton.vue?vue&type=script&lang=js"

import "./ContentButton.vue?vue&type=style&index=0&id=6756f3a9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__